export default __webpack_public_path__ + "static/media/exclusivGlas.35dbe743.jpg";